export default __webpack_public_path__ + "static/media/zeev_logo.eea7c133.png";